export enum EFieldType {
  STRING = 'string',
  NUMBER = 'number',
  BOOLEAN = 'boolean',
  OBJECT = 'object',
  ARRAY = 'array',
  CUSTOM = 'custom',
}

export const FIELD_TYPE_OPTIONS: { label: string; value: EFieldType }[] = [
  { label: 'Texte', value: EFieldType.STRING },
  { label: 'Nombre', value: EFieldType.NUMBER },
  { label: 'Booléen', value: EFieldType.BOOLEAN },
  { label: 'Objet', value: EFieldType.OBJECT },
  { label: 'Liste', value: EFieldType.ARRAY },
  { label: 'Custom', value: EFieldType.CUSTOM },
];

export const defaultValueForType = (type: EFieldType): unknown => {
  switch (type) {
    case EFieldType.NUMBER:
      return 0;
    case EFieldType.BOOLEAN:
      return false;
    case EFieldType.OBJECT:
      return {};
    case EFieldType.ARRAY:
      return [];
    case EFieldType.CUSTOM:
      return {};
    default:
      return '';
  }
};

export const coerceValueForType = (type: EFieldType, value: unknown): unknown => {
  if (type === EFieldType.NUMBER) return Number(value) || 0;
  if (type === EFieldType.BOOLEAN) return Boolean(value);
  return value ?? '';
};
